<template>
    <section class="review-company-container">
        <div class="review-company">
            <img
                class="review-company__logo"
                :src="CompanyLogo"
                :alt="typeOfCompany"
                width="98px"
                height="24px"
            >

            <div class="review-company__container">
                <Component
                    :is="typeOfStars"
                    :stars="numberOfStars"
                    :class="checkDarkMode"
                />

                <p
                    v-if="showAmount"
                    class="review-company__reviews"
                    :style="{ color: reviewsTextColor }"
                >
                    {{ amount }}
                </p>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import ZoeAtomFacebookStars from '@atoms/stars/variation-facebook/watson-atom-variation-facebook.vue';
import ZoeAtomGoogleStars from '@atoms/stars/variation-google/watson-atom-variation-google.vue';
import ZoeAtomTrustpilotStars from '@atoms/stars/variation-trustpilot/watson-atom-variation-trustpilot.vue';
import ZoeAtomYelpStars from '@atoms/stars/variation-yelp/watson-atom-variation-yelp.vue';

const props = defineProps({
    typeOfCompany: {
        type: String,
        required: false,
        default: 'trustpilot',
    },
    numberOfStars: {
        type: Number,
        required: false,
        default: 5,
    },
    showAmount: {
        type: Boolean,
        required: false,
        default: true,
    },
    amount: {
        type: String,
        required: false,
        default: '100+ reviews',
    },
    reviewsTextColor: {
        type: String,
        required: false,
        default: 'black',
    },
    darkMode: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const CompanyLogo = ref();
let imageSrc = '';

if (props.darkMode && (props.typeOfCompany === 'trustpilot')) {
    imageSrc = new URL(`../../../assets/logos/${props.typeOfCompany}-darkmode.svg`, import.meta.url).href;
} else {
    imageSrc = new URL(`../../../assets/logos/${props.typeOfCompany}.svg`, import.meta.url).href;
}

onMounted(() => {
    CompanyLogo.value = imageSrc;
});

const typeOfStars = computed(() => {
    switch (props.typeOfCompany) {
        case 'facebook':
            return ZoeAtomFacebookStars;
        case 'google':
            return ZoeAtomGoogleStars;
        case 'trustpilot':
            return ZoeAtomTrustpilotStars;
        case 'yelp':
            return ZoeAtomYelpStars;
        default:
            return null;
    }
});

const checkDarkMode = computed(() => {
    return props.darkMode ? 'review-company--dark-mode' : '';
});
</script>

<style lang="scss" scoped>
@use 'watson-molecule-review-company';
</style>
